import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Button, Divider } from "@mui/material";
import tbc from "../../images/tbc-icon.png";
import bog from "../../images/bog-icon.png";
import { useAppContext } from "../../context";
import { request } from "../../callApi";
import text from "../../Text/text.json"
import MessageBox from "../MessageBox";
import Loader from "../Loader";

export default function Transfer() {

    interface CreateOrderType {
        openBankingLinkProvider?: string;
        [key: string]: any;
    }

    const {
        createOrder,
        resHeaderHash
    } = useAppContext();

    const [alert, setAlert] = useState<{
        open: boolean;
        message: string;
        type: "success" | "error" | "warning" | "info";
    }>({
        open: false,
        message: "",
        type: "info",
    });

    const [loading, setLoading] = useState(false);

    // const [copyBankAccount, setCopyBankAccount] = React.useState('');
    const typedCreateOrder = createOrder as CreateOrderType;

    // const [copied, setCopied] = React.useState(false);
    // const iban = "GE32TB73628473849994874327";
    // let ibanList: any[] = [];
    const REACT_APP_KEEPZ_URL = process.env.REACT_APP_KEEPZ_URL


    const parseBankAccount = (bankAccount: any) => {
        if (Array.isArray(bankAccount)) return bankAccount;

        if (typeof bankAccount === "string") {
            try {
                const parsed = JSON.parse(bankAccount);
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                console.error("Invalid bankAccount JSON", e);
                return [];
            }
        }

        return [];
    };


    useEffect(() => {
        const bankAccounts = parseBankAccount(typedCreateOrder?.bankAccount);

        const selected = bankAccounts.find(
            (item: any) =>
                item.Bank === typedCreateOrder?.openBankingLinkProvider
        );

        // setCopyBankAccount(selected?.IBAN || "");
    }, [typedCreateOrder?.bankAccount, typedCreateOrder?.openBankingLinkProvider]);


    const sendOrder = async () => {
        setLoading(true);
        // console.log(resHeaderHash['X-Verification-Hash']);
        try {

            const verificationHash = localStorage.getItem("verificationHash");
            console.log("Verification hash:", verificationHash);
            
            const res = await request(
                `${REACT_APP_KEEPZ_URL}/api/Order/Create`,
                "POST",
                {
                    amount: typedCreateOrder.amount,
                    isChecked: typedCreateOrder.isChecked,
                    openBankingLinkProvider: typedCreateOrder.openBankingLinkProvider,
                    sourceCurrency: typedCreateOrder.sourceCurrency,
                    targetCurrency: typedCreateOrder.targetCurrency
                },
                {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    "channel-name": process.env.REACT_APP_CHANNEL_NAME,
                    authorization: `Bearer ${process.env.REACT_APP_AUTHORITION_TOKEN}`,
                    'x-verification-hash': verificationHash || null
                }
            );


            if (!res) {
                setAlert({
                    open: true,
                    message: "მოხდა შეცდომა, გთხოვთ სცადოთ მოგვიანებით",
                    type: "error",
                });
                return;
            }

            if (res.error) {
                const errorData = res.error;
                const rawData = errorData?.data;

                let message = "დაფიქსირდა შეცდომა";

                if (rawData) {
                    try {
                        const parsedOnce = JSON.parse(rawData);
                        const parsedTwice = JSON.parse(parsedOnce);
                        message = parsedTwice?.message ?? message;
                    } catch (e) {
                        console.error("Error parsing error message", e);
                    }
                }

                setAlert({
                    open: true,
                    message,
                    type: "error",
                });
                localStorage.removeItem("verificationHash");
                return;
            }

            if (res?.data) {
                const urlForQR = JSON.parse(res.data).urlForQR;

                window.open(urlForQR, "_blank");
                localStorage.removeItem("verificationHash");

                return;
            }


            // fallback
            setAlert({
                open: true,
                message: "მოხდა გაუთვალისწინებელი შეცდომა",
                type: "error",
            });
        } catch (e) {
            console.error("Error sending order", e);
            setAlert({
                open: true,
                message: "მოხდა შეცდომა, გთხოვთ სცადოთ მოგვიანებით",
                type: "error",
            });
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            {loading && <Loader />}
            <MessageBox
                open={alert.open}
                message={alert.message}
                type={alert.type}
                onClose={() => setAlert(prev => ({ ...prev, open: false }))}
            />

            <Box

                sx={{
                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "1fr 1fr",
                    },
                    gap: 3,
                    mb: 4,
                    width: "100%",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 1, mt: 4, maxWidth: 820, mx: "auto", px: { xs: 1, md: 2 }
                    }}
                >
                    <Button
                        className="font-helviteca"
                        variant="contained"
                        fullWidth
                        sx={{
                            background: "#FF5440",
                            color: "#FFFFFF",
                            borderRadius: "10px",
                            px: 10,
                            py: 1.4,
                            fontSize: 16,
                        }}
                        startIcon={<img src={typedCreateOrder?.openBankingLinkProvider === "TBC" ? tbc : bog} alt="BANK" style={{ width: "24px", height: "24px" }} />}
                        onClick={sendOrder}
                    >
                        გადარიცხვა
                    </Button>
                </Box>
                <Divider sx={{ my: 4 }} />

                <Box
                    sx={{ gap: 1, mt: 8, maxWidth: 820, mx: "auto", px: { xs: 1, md: 2 } }}
                >
                    <Typography
                        className="font-helviteca"
                        sx={{
                            color: "#1C3553",
                            fontWeight: 600,

                        }}
                    >
                        {text.convertationText.amount}
                    </Typography>
                    <Box sx={{ display: "flex", gap: 2, alignItems: "center", mt: 1, justifyContent: "space-between" }}>
                        <Typography
                            className="font-helviteca"
                            sx={{
                                color: "#1C3553",
                                fontSize: 14,
                            }}
                        >
                            {text.convertationText.sendAmount}
                        </Typography>
                        <Typography
                            className="font-helviteca"
                            sx={{
                                color: "#1C3553",
                                fontSize: 14,
                            }}
                        >
                            {typedCreateOrder.amount} {typedCreateOrder.sourceCurrency}
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", gap: 2, alignItems: "center", mt: 1, justifyContent: "space-between" }}>
                        <Typography
                            className="font-helviteca"
                            sx={{
                                color: "#1C3553",
                                fontSize: 14,
                            }}
                        >
                            {text.convertationText.acceptableAmount}
                        </Typography>
                        <Typography
                            className="font-helviteca"
                            sx={{
                                color: "#1C3553",
                                fontSize: 14,
                            }}
                        >
                            {typedCreateOrder.result} {typedCreateOrder.targetCurrency}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </>
    );
}